// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1I-8z","title":"Images90_title__11wxh","images":"Images90_images__3c3_D"};